import type {
  CustomBookedExtraDto,
  CleaningFeeDto,
  CleaningFeeSelectionDto,
} from '@carvia/ros-client-types';
import { httpClient } from './http-client';

class CleaningFeeReturnService {
  async getAvailableCleaningFees() {
    const res = await httpClient.get<CleaningFeeDto[]>('/cleaning-fee-return/available');
    return res.data;
  }

  async addCleaningFeeToBooking(bookingId: string, selection: CleaningFeeSelectionDto) {
    await httpClient.post(`/cleaning-fee-return/booking/${bookingId}`, selection);
  }
}

export const cleaningFeeReturnService = new CleaningFeeReturnService();
